module.exports = __webpack_public_path__ + "static/media/ehealth-red-popup-desktop-1.0.c2bfb15e.png";